export const GlutenFreeIcons = {
	SELECTED: "SELECTED",
	GREEN_DOTTED: "GREEN_DOTTED",
	GREEN_FILLED: "GREEN_FILLED",
	GREEN_OUTLINED: "GREEN_OUTLINED",
	UNKNOWN: "UNKNOWN",
	DISABLED: "DISABLED",
};

export const GlutenFreeIconsList = [
	GlutenFreeIcons.GREEN_DOTTED,
	GlutenFreeIcons.GREEN_FILLED,
	GlutenFreeIcons.GREEN_OUTLINED,
	GlutenFreeIcons.UNKNOWN,
	GlutenFreeIcons.DISABLED,
];

export const GFIIconMap = {
	[GlutenFreeIcons.GREEN_FILLED]:
		"/assets/gluten-free/one-hundred-percent-gf-icon.svg",
	[GlutenFreeIcons.GREEN_OUTLINED]:
		"/assets/gluten-free/celiac-friendly-gf-icon.svg",
	[GlutenFreeIcons.GREEN_DOTTED]:
		"/assets/gluten-free/accommodating-gf-icon.svg",
	[GlutenFreeIcons.UNKNOWN]: "/assets/gluten-free/users-three.svg",
	[GlutenFreeIcons.DISABLED]: "/assets/gluten-free/users-three.svg",
};

export const GlutenFreeIdentity = {
	ENABLED: "ENABLED",
	NO: "DISABLED",
	UNKNOWN: "UNKNOWN",
	NOT_APPLICABLE: "NOT_APPLICABLE",
};

export const GlutenFreeIdentityTitle = {
	ONE_HUNDRED_PERCENT: "100% Gluten-Free",
	CELIAC_FRIENDLY: "Celiac friendly",
	ACCOMMODATING: "Celiac accommodating",
	NOT_AWARE: "Gluten-free options",
	UNKNOWN: "Unknown",
};

export const AppliancesNames = {
	OVEN: "Oven",
	FRYER: "Fryer",
	STOVE: "Stove",
	TOASTER: "Toaster",
};
